import { render, staticRenderFns } from "./TaskTemplateInput.vue?vue&type=template&id=5b77ddc0&"
import script from "./TaskTemplateInput.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports